// ─────────────────────────────────────────
// SHARED STYLE CONSTANTS
// Used everywhere — short names so JSX stays readable.
//   ic = input class (text inputs, selects)
//   lc = label class (block labels above inputs)
// ─────────────────────────────────────────
export const ic = "w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 bg-white transition";
export const lc = "block text-sm font-medium text-slate-700 mb-1.5";

// ─────────────────────────────────────────
// FORMAT DATE OF BIRTH INPUT
// Auto-inserts slashes as user types: "01231990" -> "01/23/1990"
// ─────────────────────────────────────────
export function formatDOBInput(value) {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0,2)}/${digits.slice(2)}`;
  return `${digits.slice(0,2)}/${digits.slice(2,4)}/${digits.slice(4)}`;
}

// ─────────────────────────────────────────
// EMPTY RECORD FACTORIES
// Each step that adds rows (properties, autos, drivers, etc.)
// uses these to create a fresh blank row.
// ─────────────────────────────────────────
export function emptyLoss() {
  return { lossDate: '', lossType: '', amountPaid: '', claimClosed: false, catClaim: false };
}

export function emptyProperty() {
  return {
    propertyType: 'Primary Home', address: '', titleHolder: '',
    hasMortgage: false, escrowPremium: false,
    mortgageeName: '', mortgageeAddress: '',
    roofYear: '', roofMaterial: '', roofShape: '', roofClassIV: false,
    yearBuilt: '', squareFootage: '', constructionType: '', numFloors: '',
    hasBasement: false, basementType: '', basementSqFt: '',
    hasPool: null,
    centralFireAlarm: false, centralBurglarAlarm: false, lowTempSensor: false,
    sprinklerSystem: false, permanentGenerator: false, gatedCommunity: false, autoWaterShutoff: false,
    waterHeaterYear: '', hvacYear: '', plumbingYear: '', electricalYear: '',
    dwellingAmount: '', otherStructuresAmount: '', contentsAmount: '',
    lossOfUse: '', aopDeductible: '', liabilityLimit: '', medicalPayments: '',
    hasPriorLosses: false,
    losses: [],
    // Residence usage questions (PURE underwriting — only those NOT derivable from
    // propertyType/hasMortgage above)
    isVacant: false,
    isUnderConstruction: false,
    isForSale: false,
    isHistoricRegistry: false,
  };
}

export function emptyAuto() {
  return {
    year: '', make: '', model: '', trim: '', vin: '',
    titleHolder: '', primaryDriver: '', ownershipType: 'Owned',
    vehicleType: 'Private Passenger',
    hasCustomEquipment: false, customEquipmentAmount: '',
    keptInGarage: false, registeredInState: false,
    discountABS: false, discountPassiveRestraint: false,
    antitheftVinEtching: false, antitheftVehicleRecovery: false, antitheftDisablingDevice: false,
    vacationUse: false,
  };
}

export function emptyRecUnit() {
  return { unitType: 'Boat', year: '', make: '', model: '', titleHolder: '', primaryDriver: '' };
}

export function emptySpouse() {
  return { prefix: '', firstName: '', middleInitial: '', lastName: '', suffix: '', dateOfBirth: '' };
}